import { createBrowserHistory } from "history";

export const browserHistory = createBrowserHistory();
browserHistory.listen(location => {
  if (!(window as any).navigationHistory) {
    (window as any).navigationHistory = [];
  }
  if (browserHistory.action === "POP") {
    (window as any).navigationHistory.pop();
  } else if (browserHistory.action === "PUSH") {
    (window as any).navigationHistory.push(location.pathname);
  } else if (browserHistory.action === "REPLACE" && (window as any).navigationHistory.length > 0) {
    (window as any).navigationHistory.splice(-1, 1, location.pathname);
  }
});